import { DownloadIcon } from "@lucide/icons";

import { ButtonLink } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";
import { Popup } from "simplydo/react/ui/popup";

import type { IdeaWithCoverImage } from "../types";

type DownloadCoverImageActionProps = { idea: IdeaWithCoverImage };

const DownloadCoverImageAction = ({ idea }: DownloadCoverImageActionProps) => {
  if (idea.ownerChallenge?.preventIdeaCoverImages || !idea.coverImage) {
    return null;
  }

  return (
    <Popup
      content="Download cover image"
      trigger={
        <ButtonLink
          to={idea.coverImageUrl ?? ""}
          target="_blank"
          rel="noopener noreferrer"
          download={idea.coverImage}
        >
          <Icon icon={DownloadIcon} />
        </ButtonLink>
      }
    />
  );
};

export default DownloadCoverImageAction;
